export default "__VITE_ASSET__e7dc0f95__"